import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {TableControl} from '../../common/models/TableControl';
import {createFieldMap, getSortDirection} from '../../common/util/Util';
import {PagedFilterDTO} from '../../common/models/PagedFilterDTO';
import {EntityTable} from '../../common/types/entity-table.enum';

export class PbmRequestBuilder {

  public static getListOfSMSPagedRequestDTO(tableControl: TableControl) {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblSms;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = getSortDirection(tableControl.sortDirection);

    // Note: 'filterField' to control table filter data by 'filterValue'
    if (tableControl.filterField) {
      pagedRequestDTO.fieldMap = createFieldMap(
        tableControl.filterField,
        tableControl.filterValue
      );
    }
    else {
      pagedRequestDTO.fieldMap = null;
    }
    return pagedRequestDTO;
  }

  public static getListOfEmailPagedRequestDTO(tableControl: TableControl) {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblEmail;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = getSortDirection(tableControl.sortDirection);

    // Note: 'filterField' to control table filter data by 'filterValue'
    if (tableControl.filterField) {
      pagedRequestDTO.fieldMap = createFieldMap(
        tableControl.filterField,
        tableControl.filterValue
      );
    }
    else {
      pagedRequestDTO.fieldMap = null;
    }
    return pagedRequestDTO;
  }

  // Note: Can be used for dual purpose:
  // MatPaginator Controls
  // TableControl Fields

  public static getTableControls(length = 100,
                                 pageSize = 10,
                                 pageNumber = 0,
                                 pageSizeOptions = [5, 10, 25, 100]) {
    return {
      length,
      pageSize,
      pageNumber,
      pageSizeOptions
    };
  }
}
